export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',

  'component.notifications.operationCompleted': 'Operation completed',
  'component.notifications.successfully': 'successfully',
  'component.notifications.operationRejected': 'Operation rejected',
  'component.notifications.andUnderObservation': 'and under observation',
  'component.notifications.completeInformation': 'Complete information',
  'component.notifications.attachDocument': 'Attach document',
  'component.notifications.confirmDelete': 'Are you sure you want to delete this item?',
  'component.notifications.confirmReject': 'Rejection reason',
  'component.notifications.confirmApprove': 'Approval comments',

  'component.filters.SearchInput.placeholder': 'Filter by typing a word',
  /* Ace form fields — edit-mode defaults (hidden in details/view-only, like DatePicker). */
  'component.aceInput.placeholder.text': 'Enter text...',
  'component.aceInput.placeholder.number': 'Enter number',
  'component.aceInput.placeholder.select': 'Select',
  'component.results': 'results',
  'component.errorBoundary.message': 'Something went wrong.',
  'component.errorBoundary.title': 'Oops! Something went wrong',
  'component.errorBoundary.subtitle':
    'Sorry, an unexpected error has occurred. Please try refreshing the page.',
  'component.errorBoundary.refresh': 'Refresh page',
  'component.remote.search.placeholder': 'Type at least one character to search',

  'component.user.profilePhoto': 'profile photo',
  'component.user.userProfilePhoto': 'User profile photo',
  'component.user.userProfile': 'User profile',
  'component.user.profile': 'profile',
  'component.user.loadingProfilePhoto': 'Loading profile photo',
  'component.user.nameProfilePhoto': "{name}'s profile photo",
  'component.user.userIdProfilePhoto': "User {id}'s profile photo",
  'component.user.nameProfile': "{name}'s profile",
  'component.user.nameInitials': 'User initials',
  'component.user.defaultAvatar': 'User avatar',

  // ─── EntitySelector — reusable multi-picker ──────────────────────────────
  'entitySelector.connection.empty': 'Link a connection so this agent can use it',
  'entitySelector.connection.emptyHint': 'Link a connection so this agent can use it',
  'entitySelector.connection.add': 'Add connection',
  'entitySelector.connection.create': 'Create new connection',
  'entitySelector.connection.search': 'Search connections…',
  'entitySelector.connection.noResults': 'No connections found',

  'entitySelector.skill.empty': 'Link a skill to extend what this agent can do',
  'entitySelector.skill.emptyHint': 'Link a skill to extend what this agent can do',
  'entitySelector.skill.add': 'Add skill',
  'entitySelector.skill.create': 'Create new skill',
  'entitySelector.skill.search': 'Search skills…',
  'entitySelector.skill.noResults': 'No skills found',

  'entitySelector.vector.empty': 'Link a vector to give this agent knowledge to search',
  'entitySelector.vector.emptyHint': 'Link a vector to give this agent knowledge to search',
  'entitySelector.vector.add': 'Add vector',
  'entitySelector.vector.create': 'Create new vector',
  'entitySelector.vector.search': 'Search vectors…',
  'entitySelector.vector.noResults': 'No vectors found',

  'entitySelector.memory.empty': 'Link a memory so this agent can recall context',
  'entitySelector.memory.emptyHint': 'Link a memory so this agent can recall context',
  'entitySelector.memory.add': 'Add memory',
  'entitySelector.memory.create': 'Create new memory',
  'entitySelector.memory.search': 'Search memories…',
  'entitySelector.memory.noResults': 'No memories found',

  'entitySelector.aiTool.empty': 'Enable a built-in tool for this agent',
  'entitySelector.aiTool.emptyHint': 'Enable a built-in tool for this agent',
  'entitySelector.aiTool.add': 'Add tool',
  'entitySelector.aiTool.create': 'Create new tool',
  'entitySelector.aiTool.search': 'Search tools…',
  'entitySelector.aiTool.noResults': 'No tools found',

  'entitySelector.appAuthMode.empty': 'Choose the authentication mode',
  'entitySelector.appAuthMode.emptyHint': 'Native or Public',
  'entitySelector.appAuthMode.add': 'Choose mode',
  'entitySelector.appAuthMode.create': 'Create authentication mode',
  'entitySelector.appAuthMode.search': 'Search modes…',
  'entitySelector.appAuthMode.noResults': 'No modes found',

  'entitySelector.aiAgentTeam.empty': 'Assign this agent to an administrative team',
  'entitySelector.aiAgentTeam.emptyHint': 'Assign this agent to an administrative team',
  'entitySelector.aiAgentTeam.add': 'Assign team',
  'entitySelector.aiAgentTeam.create': 'Create new team',
  'entitySelector.aiAgentTeam.search': 'Search teams…',
  'entitySelector.aiAgentTeam.noResults': 'No teams found',

  'entitySelector.aiSkillGroup.empty': 'Group this skill into a folder',
  'entitySelector.aiSkillGroup.emptyHint': 'Group this skill into a folder',
  'entitySelector.aiSkillGroup.add': 'Assign group',
  'entitySelector.aiSkillGroup.create': 'Create new group',
  'entitySelector.aiSkillGroup.search': 'Search groups…',
  'entitySelector.aiSkillGroup.noResults': 'No groups found',

  'entitySelector.customListGroup.empty': 'Assign this list to a group',
  'entitySelector.customListGroup.emptyHint': 'Assign this list to a group',
  'entitySelector.customListGroup.add': 'Assign group',
  'entitySelector.customListGroup.create': 'Create new group',
  'entitySelector.customListGroup.search': 'Search list groups…',
  'entitySelector.customListGroup.noResults': 'No groups found',

  'entitySelector.documentFolder.empty': 'Choose a destination folder',
  'entitySelector.documentFolder.emptyHint': 'Choose a destination folder',
  'entitySelector.documentFolder.add': 'Choose folder',
  'entitySelector.documentFolder.create': 'New folder',
  'entitySelector.documentFolder.search': 'Search folders…',
  'entitySelector.documentFolder.noResults': 'No folders found',

  'entitySelector.processGroup.empty': 'Assign this process to a group',
  'entitySelector.processGroup.emptyHint': 'Assign this process to a group',
  'entitySelector.processGroup.add': 'Assign group',
  'entitySelector.processGroup.create': 'Create new group',
  'entitySelector.processGroup.search': 'Search process groups…',
  'entitySelector.processGroup.noResults': 'No groups found',

  'entitySelector.connectionGroup.empty': 'Assign this connection to a group',
  'entitySelector.connectionGroup.emptyHint': 'Assign this connection to a group',
  'entitySelector.connectionGroup.add': 'Assign group',
  'entitySelector.connectionGroup.create': 'Create new group',
  'entitySelector.connectionGroup.search': 'Search connection groups…',
  'entitySelector.connectionGroup.noResults': 'No groups found',

  'entitySelector.dynamicEntityGroup.empty': 'Assign this entity to a group',
  'entitySelector.dynamicEntityGroup.emptyHint': 'Assign this entity to a group',
  'entitySelector.dynamicEntityGroup.add': 'Assign group',
  'entitySelector.dynamicEntityGroup.create': 'Create new group',
  'entitySelector.dynamicEntityGroup.search': 'Search entity groups…',
  'entitySelector.dynamicEntityGroup.noResults': 'No groups found',

  'entitySelector.process.empty': 'Link a process to this permission',
  'entitySelector.process.emptyHint': 'Link a process to this permission',
  'entitySelector.process.add': 'Add process',
  'entitySelector.process.create': 'Create new process',
  'entitySelector.process.search': 'Search processes…',
  'entitySelector.process.noResults': 'No processes found',

  'entitySelector.list.empty': 'Link a list to this permission',
  'entitySelector.list.emptyHint': 'Link a list to this permission',
  'entitySelector.list.add': 'Add list',
  'entitySelector.list.create': 'Create new list',
  'entitySelector.list.search': 'Search lists…',
  'entitySelector.list.noResults': 'No lists found',

  'entitySelector.report.empty': 'Link a report to this permission',
  'entitySelector.report.emptyHint': 'Link a report to this permission',
  'entitySelector.report.add': 'Add report',
  'entitySelector.report.create': 'Create new report',
  'entitySelector.report.search': 'Search reports…',
  'entitySelector.report.noResults': 'No reports found',

  'entitySelector.entity.empty': 'Link an entity to this permission',
  'entitySelector.entity.emptyHint': 'Link an entity to this permission',
  'entitySelector.entity.add': 'Add entity',
  'entitySelector.entity.create': 'Create new entity',
  'entitySelector.entity.search': 'Search entities…',
  'entitySelector.entity.noResults': 'No entities found',

  'entitySelector.aiAgent.empty': 'Link an AI agent to this permission',
  'entitySelector.aiAgent.emptyHint': 'Link an AI agent to this permission',
  'entitySelector.aiAgent.add': 'Add AI agent',
  'entitySelector.aiAgent.create': 'Create new AI agent',
  'entitySelector.aiAgent.search': 'Search AI agents…',
  'entitySelector.aiAgent.noResults': 'No AI agents found',

  'entitySelector.user.empty': 'Link a user',
  'entitySelector.user.emptyHint': 'Link a user',
  'entitySelector.user.add': 'Add user',
  'entitySelector.user.create': 'Create new user',
  'entitySelector.user.search': 'Search users…',
  'entitySelector.user.noResults': 'No users found',

  'entitySelector.userTask.empty': 'Link one of your tasks',
  'entitySelector.userTask.emptyHint': 'Link one of your tasks',
  'entitySelector.userTask.add': 'Link task',
  'entitySelector.userTask.create': 'Create new task',
  'entitySelector.userTask.search': 'Search tasks…',
  'entitySelector.userTask.noResults': 'No tasks found',

  'entitySelector.userGroup.empty': 'Link a group',
  'entitySelector.userGroup.emptyHint': 'Link a group',
  'entitySelector.userGroup.add': 'Add group',
  'entitySelector.userGroup.create': 'Create new group',
  'entitySelector.userGroup.search': 'Search groups…',
  'entitySelector.userGroup.noResults': 'No groups found',

  'entitySelector.position.empty': 'Link a position',
  'entitySelector.position.emptyHint': 'Link a position',
  'entitySelector.position.add': 'Add position',
  'entitySelector.position.create': 'Create new position',
  'entitySelector.position.search': 'Search positions…',
  'entitySelector.position.noResults': 'No positions found',

  'entitySelector.area.empty': 'Link an area',
  'entitySelector.area.emptyHint': 'Link an area',
  'entitySelector.area.add': 'Add area',
  'entitySelector.area.create': 'Create new area',
  'entitySelector.area.search': 'Search areas…',
  'entitySelector.area.noResults': 'No areas found',

  'entitySelector.generic.empty': 'No items linked yet',
  'entitySelector.generic.emptyHint': 'No items linked yet',
  'entitySelector.generic.add': 'Add',
  'entitySelector.generic.change': 'Change',
  'entitySelector.generic.create': 'Create new',
  'entitySelector.generic.search': 'Search…',
  'entitySelector.generic.noResults': 'No results',
  'entitySelector.generic.notSupported': 'Quick creation is not available here',
  'entitySelector.created.added': 'Created and added to selection',
  'entitySelector.created.refreshed': 'List refreshed with new item',

  // ─── CollaboratorsDrawer — shared across the 4 domains that follow ──
  //     the "AccessControl vs Collaborator" UX guide (DynamicEntity,
  //     CustomList, App, AIAgent).
  'collaboratorsDrawer.title': 'Collaborators',
  'collaboratorsDrawer.addSection': 'Add collaborators',
  'collaboratorsDrawer.selectUsers': 'Select users',
  'collaboratorsDrawer.usersRequired': 'Select at least one user',
  'collaboratorsDrawer.add': 'Add collaborator',
  'collaboratorsDrawer.current': 'Current collaborators',
  'collaboratorsDrawer.empty': 'No collaborators yet',
  'collaboratorsDrawer.remove.content':
    'Are you sure you want to remove {userName} as a collaborator?',
};
